'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/productCarousel')); // 54916
    processInclude(require('plugin_wishlists/product/wishlist'));
    // 301606
    $("body").on("click", "a.link-scrawl", function (e) {
        e.preventDefault();
        var offset;
        var headerBannerOffset = window.sessionStorage.getItem('hide_header_banner');
        var additionalOffset = 20;
        if (!$('body').hasClass('nav-sticky')) {
            if (headerBannerOffset === null) {
                additionalOffset = 80;
            }
            offset = $('.st-global-header__nav').height() + additionalOffset;
        } else {
            offset = $('.st-global-header__nav').height() + additionalOffset;
        }
        console.log(additionalOffset);
        var linkid = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(linkid).offset().top - offset
        }, 500);
    });
});

